export const MESSAGE_STATUS = {
    NEW: 1,
    OPEN: 2,
    IN_PROGRESS: 3,
    CLOSED: 4,
};

export const MESSAGE_STATUS_FILTER = {
    ALL: "",
    NEW: "new",
    IN_PROGRESS: "in_progress",
    CLOSED: "closed",
};

export function getMessageStatusFilterValue(status) {
    if (status === MESSAGE_STATUS.NEW) {
        return MESSAGE_STATUS_FILTER.NEW;
    }
    if (
        status === MESSAGE_STATUS.OPEN ||
        status === MESSAGE_STATUS.IN_PROGRESS
    ) {
        return MESSAGE_STATUS_FILTER.IN_PROGRESS;
    }
    if (status === MESSAGE_STATUS.CLOSED) {
        return MESSAGE_STATUS_FILTER.CLOSED;
    }
    return null;
}

const STATUS_LABEL_KEYS = {
    [MESSAGE_STATUS_FILTER.NEW]: "Organizational.Messages.Status.New",
    [MESSAGE_STATUS_FILTER.IN_PROGRESS]:
        "Organizational.Messages.Status.InProgress",
    [MESSAGE_STATUS_FILTER.CLOSED]: "Organizational.Messages.Status.Closed",
};

export function messageStatusLabelKey(status) {
    const value = getMessageStatusFilterValue(status);
    return value ? STATUS_LABEL_KEYS[value] : null;
}

export function messageStatusFilterOptions(t) {
    return [
        {
            value: MESSAGE_STATUS_FILTER.ALL,
            label: t("Organizational.Messages.Status.All"),
        },
        {
            value: MESSAGE_STATUS_FILTER.NEW,
            label: t("Organizational.Messages.Status.New"),
        },
        {
            value: MESSAGE_STATUS_FILTER.IN_PROGRESS,
            label: t("Organizational.Messages.Status.InProgress"),
        },
        {
            value: MESSAGE_STATUS_FILTER.CLOSED,
            label: t("Organizational.Messages.Status.Closed"),
        },
    ];
}
